import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import { Btn, LI } from '../../../AbstractElements';
import { LogOut } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { cookies } from '../../../utils';

const LogoutClass = () => {
    const Logout = () => {
        localStorage.removeItem('IwoCashToken');
        localStorage.removeItem('entity_name');
        localStorage.removeItem('full_name');
        localStorage.removeItem('company_id');
        localStorage.removeItem('country_name');
        localStorage.removeItem('company_name');
        localStorage.removeItem('username');
        localStorage.removeItem('company_logo');
        localStorage.removeItem('infos');
        localStorage.removeItem('permissions');
        // cookies.reset('iwoUser')
        // cookies.reset('cashUser',{domain: ''})
        cookies.reset('cashUser',{domain: '.iwo.bj'})
        window.location.reload(false);
    };

    return (
        <Fragment>
            <LI attrLI={{ className: 'onhover-dropdown p-0', onClick: Logout }} >
                <Btn attrBtn={{ as: Card.Header, className: 'btn btn-primary-light',  }} >
                    <Link to='/login'>
                        <LogOut />Déconnexion
                    </Link>
                </Btn>
            </LI>
        </Fragment>
    );
};

export default LogoutClass;